import { render, staticRenderFns } from "./UnlockOpportunities.vue?vue&type=template&id=2db74ff1&scoped=true"
import script from "./UnlockOpportunities.vue?vue&type=script&lang=js"
export * from "./UnlockOpportunities.vue?vue&type=script&lang=js"
import style0 from "./UnlockOpportunities.vue?vue&type=style&index=0&id=2db74ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db74ff1",
  null
  
)

export default component.exports